var React = require('react');

function Plus (props) {
    return React.createElement("svg",props,React.createElement("text",{"transform":"translate(-1 -220)","fill":"#3d4e56","fillRule":"evenodd","fontFamily":"CircularStd-Book, Circular Std","fontSize":"24","fontWeight":"300"},React.createElement("tspan",{"x":"0","y":"233"},"+")));
}

Plus.defaultProps = {"width":"12","height":"12","viewBox":"0 0 12 12"};

module.exports = Plus;

Plus.default = Plus;
